import { Flex, Link, Typography } from '@iheartjane/reefer';
import { useFormContext, useWatch } from '@iheartjane/reefer-hook-form';
import type { ReactNode } from 'react';
import { useMemo } from 'react';

type DefaultValue = string | { display: string; value: string };

export const RevertableInputWrapper = ({
  defaultValue,
  initialValue,
  name,
  fromPOS,
  children,
}: {
  children: ReactNode;
  defaultValue: DefaultValue;
  fromPOS?: boolean;
  initialValue?: string;
  name: string;
}) => {
  const { setValue } = useFormContext();
  // Can't explain it but if you just use "watch" here,
  // you'll get an undefined value initially no matter how you set this field
  const value = useWatch({ name, defaultValue: initialValue });

  const defaultDisplayValue =
    typeof defaultValue === 'object' ? defaultValue?.display : defaultValue;

  const defaultRevertValue =
    typeof defaultValue === 'object' ? defaultValue?.value : defaultValue;

  const isDefaultValue = useMemo(
    () => value !== null && value === defaultRevertValue,
    [value, defaultRevertValue]
  );

  const revert = () => {
    setValue(name, defaultRevertValue, { shouldDirty: true });
  };

  return (
    <div style={{ width: '100%' }}>
      {children}
      {defaultValue !== null && !isDefaultValue ? (
        <Flex justifyContent="space-between" data-testid={`revertable-${name}`}>
          <Typography color="grays-mid" mt={8} mr={12}>
            {fromPOS ? 'POS d' : 'D'}efault: {defaultDisplayValue}
          </Typography>
          <Link mt={8} onClick={revert}>
            Revert
          </Link>
        </Flex>
      ) : null}
    </div>
  );
};
